import React from 'react';
import { motion } from 'framer-motion';
import type { MenuItem } from '../../types';

interface MobileNavigationProps {
  menuItems: MenuItem[];
  activeSection: string;
  onSectionChange: (section: string) => void;
}

const MobileNavigation: React.FC<MobileNavigationProps> = ({
  menuItems,
  activeSection,
  onSectionChange
}) => {
  const handleSectionClick = (section: string) => {
    onSectionChange(section);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-background/60 backdrop-blur-xl border-t border-white/10 pb-[env(safe-area-inset-bottom,0px)] z-50">
      <div className="relative py-1">
        {/* Gradiente de fundo */}
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/98 to-background/20" />
        
        {/* Efeito de brilho */}
        <div className="absolute inset-0"
          style={{
            background: 'radial-gradient(circle at 50% 0%, rgba(0,149,255,0.15) 0%, transparent 70%)'
          }}
        />

        <div className="relative flex justify-around items-center">
          {menuItems.map((item) => {
            const isActive = activeSection === item.section;
            const Icon = item.icon;

            return (
              <motion.button
                key={item.id}
                onClick={() => handleSectionClick(item.section)}
                className={`flex flex-col items-center gap-1 p-2 rounded-xl transition-all duration-300 ${
                  isActive 
                    ? 'text-primary bg-primary/10' 
                    : 'text-gray-400 hover:text-gray-300'
                }`}
                whileTap={{ scale: 0.9 }}
                animate={{
                  scale: isActive ? 1.1 : 1,
                  y: isActive ? -2 : 0
                }}
              >
                <div className="relative">
                  <motion.div
                    initial={false}
                    animate={{
                      rotate: isActive ? 20 : 0
                    }}
                    transition={{ type: "spring", stiffness: 200, damping: 10 }}
                  >
                    <Icon className="w-5 h-5" />
                  </motion.div>
                  {isActive && (
                    <motion.div
                      layoutId="activeIndicator"
                      className="absolute -inset-3 bg-primary/20 rounded-lg -z-10"
                      transition={{ type: "spring", stiffness: 260, damping: 20 }}
                    />
                  )}
                  {/* Efeito de brilho no ícone ativo */}
                  {isActive && (
                    <motion.div
                      className="absolute -inset-3 bg-primary/30 rounded-lg blur-md -z-20"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: [0.5, 0.3, 0.5] }}
                      transition={{ duration: 2, repeat: Infinity }}
                    />
                  )}
                </div>
                <span className="text-xs font-medium opacity-90">{item.label}</span>
              </motion.button>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default MobileNavigation; 